/*@flow*/

export default (e: {
  response?: any,
  message?: string,
  errors: string[],
}): Promise<string[]> => {
  return new Promise((res) => {
    if (e.response) {
      let errors = [];
      e.response
        .json()
        .then((body) => {
          const msg = body.message;
          if (msg) {
            errors.push(msg);
          } else if (body.errors && Array.isArray(body.errors)) {
            errors = errors.concat(body.errors);
          }
          res(errors);
        })
        .catch(() => {
          if (e.message) {
            errors = [e.message];
            res(errors);
          }
        });
    } else {
      res([]);
    }
  });
};
